import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.5 14.1667H4.5C3.76362 14.1667 3.16667 13.5697 3.16667 12.8333V3.16667C3.16667 2.43029 3.76362 1.83333 4.5 1.83333H11.5C12.2364 1.83333 12.8333 2.43029 12.8333 3.16667V7.16667"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.83333 12.7221L10.2619 14.1667L13.8333 9.83333"
    />
  </svg>
);
export default SvgFileCheck;
